"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParameter = void 0;
const storage_1 = require("../extension/storage");
const getUrlParameter = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const results = new RegExp(`[\\?&]${name}=([^&#]*)`).exec(location.search);
    return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
};
exports.getUrlParameter = getUrlParameter;
const BEARER_TOKEN_STORAGE_KEY = '789eyrhgugibnv';
const EXPIRE_AT_STORAGE_KEY = 'v7uds8hifbr789';
/**
 * Classe per la gestione del token di accesso
 *
 * @export
 * @class AuthToken
 */
class AuthToken {
    /**
     * Inizializza il token dallo storage
     * @memberof AuthToken
     */
    constructor() {
        /**
         * Controlla se il token è stato validato dal server
         * @private
         * @type {boolean}
         * @memberof AuthToken
         */
        this.bValid = false;
        // this.setAccessToken(getUrlParameter('bearerToken') || storage.get('bearerToken', null))
        // this.setExpireAt(parseInt(getUrlParameter('expireAt') || storage.get('expireAt', '0')))
        this.setAccessToken(storage_1.Storage.get(BEARER_TOKEN_STORAGE_KEY, null));
        this.setExpireAt(parseInt(storage_1.Storage.get(EXPIRE_AT_STORAGE_KEY, '0')));
    }
    /**
     * Inizializza il token
     *
     * @param {any} response
     * @memberof AuthToken
     */
    createFromResponse(response) {
        this.setAccessToken(response.bearerToken);
        // this.setExpireAtFromTTL(response.expireAt)
        this.setExpireAt(response.expireAt);
        this.setValid(true);
    }
    /**
     * Cancella il token
     *
     * @memberof AuthToken
     */
    destroy() {
        this.setAccessToken(null);
        this.setExpireAt(null);
        this.setValid(false);
    }
    /**
     * Controlla se il token è settato
     *
     * @returns {boolean}
     * @memberof AuthToken
     */
    exists() {
        return this.getAccessToken() !== null;
    }
    /**
     * Controlla se il token è scauto
     *
     * @param {number} [expireAt=this.expireAt]
     * @returns {boolean}
     * @memberof AuthToken
     */
    isExpired(expireAt = this.expireAt) {
        return expireAt ? Date.now() > expireAt : true;
    }
    /**
     * Ritorna il token
     *
     * @returns {string}
     * @memberof AuthToken
     */
    getAccessToken() {
        return this.bearerToken;
    }
    /**
     * Setta il token
     *
     * @param {string} bearerToken
     * @memberof AuthToken
     */
    setAccessToken(bearerToken) {
        if (bearerToken) {
            this.bearerToken = bearerToken;
            storage_1.Storage.set(BEARER_TOKEN_STORAGE_KEY, this.bearerToken);
        }
        else {
            this.bearerToken = null;
            storage_1.Storage.remove(BEARER_TOKEN_STORAGE_KEY);
        }
    }
    /**
     * Ritorna il timestamp di espiazione del token
     *
     * @returns {number}
     * @memberof AuthToken
     */
    getExpireAt() {
        return this.expireAt;
    }
    /**
     * Setta la data di espiazione del token
     *
     * @param {number} expireAt timestamp
     * @memberof AuthToken
     */
    setExpireAt(expireAt) {
        if (expireAt) {
            this.expireAt = expireAt;
            storage_1.Storage.set(EXPIRE_AT_STORAGE_KEY, this.expireAt.toString());
        }
        else {
            this.expireAt = null;
            storage_1.Storage.remove(EXPIRE_AT_STORAGE_KEY);
        }
    }
    /**
     * Setta la data di espiazione del token da un tempo di scadenza (ttl)
     *
     * @param {number} expireAt_ttl
     * @memberof AuthToken
     */
    setExpireAtFromTTL(expireAt_ttl) {
        this.setExpireAt(Date.now() + expireAt_ttl * 1000);
    }
    /**
     * Controlla se il token è stato validato dal server
     *
     * @returns {boolean}
     * @memberof AuthToken
     */
    isValid() {
        return this.bValid;
    }
    /**
     * Setta la validità del token
     *
     * @param {boolean} bValid
     * @memberof AuthToken
     */
    setValid(bValid) {
        this.bValid = bValid;
    }
}
exports.default = AuthToken;
